// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"105":"4520ff256a21251d","340":"74516fdc9a886f5f"}[chunkId] + ".js";
};